module.exports = __webpack_public_path__ + "img/Monte_Kope_123.53f5f2a9.jpg";